const DEFAULT_ENV = 'pre_prod';

export const SITES = Object.freeze({
  BETBG: 'BETBG',
  EFBET: 'EFBET'
});

const FAVICONS = {
  [SITES.BETBG]: '/betbg_favicon.svg',
  [SITES.EFBET]: '/efbet_favicon.svg'
};

export const ENVS = Object.freeze({
  DEV: 'dev',
  STAGING: 'staging',
  CUCUMBER: 'cucumber',
  PRE_PROD: 'pre_prod',
  PROD: 'prod'
});

const DOMAINS = Object.freeze({
  [SITES.BETBG]: Object.freeze({
    dev: 'https://apigw-dev.efbet.tech/api/v1',
    staging: 'https://apigw-staging.efbet.tech/api/v1',
    cucumber: 'https://apigw-cucumber.efbet.tech/api/v1',
    pre_prod: 'https://apigw-pre-prod.efbet.tech/api/v1',
    prod: 'https://apigw.bet.bg/api/v1'
  }),

  //TODO Add new domains for efbet prod environment, to work correctly!
  [SITES.EFBET]: Object.freeze({
    dev: '',
    staging: '',
    cucumber: '',
    pre_prod: 'https://apigw-pre-prod.efbet.dev/api/v1',
    prod: 'https://apigw.efbet.com/api/v1'
  })
});

const rawEnv = (process.env.REACT_APP_ENV || DEFAULT_ENV).trim();
export const rawSiteId = (process.env.REACT_APP_SITE_ID || '')
  .trim()
  .toUpperCase();

const isValidEnv = value => Object.values(ENVS).includes(value);
const isValidSite = value => Object.values(SITES).includes(value);

const DEFAULT_LANG = 'BG';
export const siteFavicon = FAVICONS[rawSiteId];
export const BUSINESS_UNIT = process.env.REACT_APP_BUSINESS_UNIT || '';

export const FALLBACK_PATH = `/${BUSINESS_UNIT}/${DEFAULT_LANG}`;

const env = isValidEnv(rawEnv) ? rawEnv : DEFAULT_ENV;

if (!rawSiteId) {
  throw new Error('[config] Missing required env var: REACT_APP_SITE_ID');
}

if (!isValidSite(rawSiteId)) {
  throw new Error(
    `[config] Invalid REACT_APP_SITE_ID: "${rawSiteId}". Allowed: ${Object.values(
      SITES
    ).join(', ')}`
  );
}

const siteId = rawSiteId;

const serviceDomain = DOMAINS?.[siteId]?.[env];
if (!serviceDomain) {
  throw new Error(
    `[config] No domain configured for site "${siteId}" and env "${env}". ` +
      `Check DOMAINS map and REACT_APP_ENV.`
  );
}

export const IS_EFBET = siteId === SITES.EFBET;

const CONSTANTS = Object.freeze({
  env,
  siteId,
  serviceDomain,

  defaultLang: 'BG',
  breakpointMobile: 900,

  // TODO: should come from BE
  countryCodeRomania: 'RO'
});

export default CONSTANTS;
